<ng-container *transloco="let t">
  @if (
    {
      activeLang: activeLang$ | async,
      readOnly: readOnly$ | async,
    };
    as data
  ) {
    <div class="form-group question-container-inner" [formGroup]="questionForm">
      <lib-input-container
        [markRequired]="true"
        [headLine]="
          question.translations?.list['headLine']
            | translate: data.activeLang : question.structure.headLine
        "
        [description]="
          question.translations?.list['description']
            | translate: data.activeLang : question.structure.description
        "
        [hideBelow]="true"
        [hideAbove]="true"
      >
        <div class="classification-type">
          <lib-classification-type
            [label]="t('classifications_description_BO_title')"
            [typeId]="ClassificationTypes.BO"
            (classificationAnswer)="updateAnswer($event)"
            [parsedClassificationAnswer]="parsedClassificationAnswer()?.BO"
            [readOnlyState]="data.readOnly"
            [questionId]="question.id"
            [showChangeIndicatorForIds]="
              showChanges()
                ? previousAnswersService.getChangedClassificationIds(
                    question.id,
                    repeaterGroupId,
                    parsedClassificationAnswer()?.BO?.choosenItems,
                    'BO'
                  )
                : []
            "
          >
          </lib-classification-type>
        </div>
        <div class="classification-type">
          <lib-classification-type
            [label]="t('classifications_description_FO_title')"
            [typeId]="ClassificationTypes.FO"
            (classificationAnswer)="updateAnswer($event)"
            [parsedClassificationAnswer]="parsedClassificationAnswer()?.FO"
            [readOnlyState]="data.readOnly"
            [questionId]="question.id"
            [showChangeIndicatorForIds]="
              showChanges()
                ? previousAnswersService.getChangedClassificationIds(
                    question.id,
                    repeaterGroupId,
                    parsedClassificationAnswer()?.FO?.choosenItems,
                    'FO'
                  )
                : []
            "
          >
          </lib-classification-type>
        </div>
        <div class="classification-type">
          <lib-classification-type
            [label]="t('classifications_description_PO_title')"
            [typeId]="ClassificationTypes.PO"
            (classificationAnswer)="updateAnswer($event)"
            [parsedClassificationAnswer]="parsedClassificationAnswer()?.PO"
            [readOnlyState]="data.readOnly"
            [questionId]="question.id"
            [showChangeIndicatorForIds]="
              showChanges()
                ? previousAnswersService.getChangedClassificationIds(
                    question.id,
                    repeaterGroupId,
                    parsedClassificationAnswer()?.PO?.choosenItems,
                    'PO'
                  )
                : []
            "
          >
          </lib-classification-type>
        </div>
      </lib-input-container>
    </div>
  }
</ng-container>
